module.exports = __webpack_public_path__ + "static/03-5621e345ec578f15c70910550ee95aa4.jpg";